import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// Event_Contract_ADD
export const addOpenSign = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.OPEN_SIGN_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};